module.exports = __webpack_public_path__ + "static/newmarblehillhouse-1dbfb2733983fe32c0cf825bf7cca9b8.jpg";